type ParcoursStatus = 'draft' | 'published' | 'archived';

const STYLES: Record<ParcoursStatus, string> = {
  draft:     'bg-slate-100 text-slate-600',
  published: 'bg-emerald-50 text-emerald-700',
  archived:  'bg-amber-50 text-amber-600',
};

const LABELS: Record<ParcoursStatus, string> = {
  draft:     'Brouillon',
  published: 'Publié',
  archived:  'Archivé',
};

interface Props {
  status: ParcoursStatus;
}

export default function ParcoursStatusBadge({ status }: Props) {
  return (
    <span className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium ${STYLES[status]}`}>
      {LABELS[status]}
    </span>
  );
}
